import { WritableSignal } from '@angular/core';
import { Observable, finalize, defer } from 'rxjs';

function prepare<T>(callback: () => void): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> => defer(() => {
    callback();
    
    return source;
  });
}

export function indicateLoading<T>(
  indicator: WritableSignal<any>,
  triggerValue: any = true
): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> => source.pipe(
    prepare(() => indicator.set(triggerValue)),
    finalize(() => {
      const nullishValue = typeof triggerValue === 'boolean' ? false : null;

      indicator.set(nullishValue);
    })
  );
}